"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IllegalArgumentException = exports.CljError = void 0;
class CljError extends Error {
}
exports.CljError = CljError;
class IllegalArgumentException extends CljError {
}
exports.IllegalArgumentException = IllegalArgumentException;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXJyb3JzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3V0aWxzL2Vycm9ycy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxNQUFhLFFBQVMsU0FBUSxLQUFLO0NBQUc7QUFBdEMsNEJBQXNDO0FBQ3RDLE1BQWEsd0JBQXlCLFNBQVEsUUFBUTtDQUFHO0FBQXpELDREQUF5RCJ9